import { OverrideComponent, MuiComponents } from './types';

export const MuiLink: OverrideComponent = () => {
  const MuiLink: MuiComponents['MuiLink'] = {
    styleOverrides: {
      root: {
        cursor: 'pointer',
      },
    },
  };

  return {
    MuiLink,
  };
};
